import { render } from "./getStudentsList.vue?vue&type=template&id=4c1e6637&scoped=true"
import script from "./getStudentsList.vue?vue&type=script&lang=js"
export * from "./getStudentsList.vue?vue&type=script&lang=js"

import "./getStudentsList.vue?vue&type=style&index=0&id=4c1e6637&scoped=true&lang=css"
import "./getStudentsList.vue?vue&type=style&index=1&id=4c1e6637&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1e6637"]])

export default __exports__